import { render, staticRenderFns } from "./ModalMakeDelivery.vue?vue&type=template&id=9fd998fe&scoped=true&"
import script from "./ModalMakeDelivery.vue?vue&type=script&lang=ts&"
export * from "./ModalMakeDelivery.vue?vue&type=script&lang=ts&"
import style0 from "./ModalMakeDelivery.vue?vue&type=style&index=0&id=9fd998fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd998fe",
  null
  
)

export default component.exports